import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { createSelector } from 'reselect';
import { getStringProp, values } from '@mews/fp';
import { isAgeCategoryAdultClassification } from '../../../modules/entities/ageCategories/selectors';
import { OccupancyData } from '../../../modules/resourceOrder/occupancyTypes';
import { parentSelector } from '../../../selectors/parentSelector';
import { ApplicationState } from '../../../types';
import { WithEnterpriseId } from '../../../types/selectors/selectorPropTypes';
import { ConfigurationOccupancy } from './occupancy';

const getDates = createSelector(parentSelector, (state) => state.dates);

export const getDatesOccupancy = createSelector(getDates, (dates) => dates.dateOccupancy);

export const getEnterpriseDatesOccupancy = createSelector(
    getDates,
    getStringProp('enterpriseId'),
    (dates, enterpriseId): ConfigurationOccupancy => dates.dateOccupancy[enterpriseId] ?? {}
);

const getDatesAgeCategory = createSelector(
    getStringProp('ageCategoryId'),
    getEnterpriseDatesOccupancy,
    (ageCategoryId, dateOccupancy) => dateOccupancy?.[ageCategoryId]
);

export const getDatesAgeCategoryIds = createSelector(getEnterpriseDatesOccupancy, (datesOccupancy) =>
    Object.keys(datesOccupancy)
);

export const getDatesOccupancyDataPersonCount = createSelector(
    getDatesAgeCategory,
    (dateAgeCategory) => dateAgeCategory?.personCount ?? 0
);

const getDatesChildCountAndAdultCount = (state: ApplicationState, { enterpriseId }: WithEnterpriseId) =>
    pipe(
        getEnterpriseDatesOccupancy(state, { enterpriseId }),
        values,
        array.reduce({ adultCount: 0, childCount: 0 }, (acc, occupancy: OccupancyData) => {
            if (isAgeCategoryAdultClassification(state, { ageCategoryId: occupancy.ageCategoryId })) {
                acc.adultCount += occupancy.personCount;
            } else {
                acc.childCount += occupancy.personCount;
            }
            return acc;
        })
    );

export const getDatesOccupancyAdultSum = createSelector(
    getDatesChildCountAndAdultCount,
    (datesChildCountAndAdultCount) => datesChildCountAndAdultCount.adultCount
);

export const getDatesOccupancyPersonSum = createSelector(
    getDatesChildCountAndAdultCount,
    (datesChildCountAndAdultCount) => datesChildCountAndAdultCount.adultCount + datesChildCountAndAdultCount.childCount
);
